import loadScript from 'sign_up/load_script'
import submitSignUp from 'sign_up/submit'

// Takes over the sign-in form's submit only while "New Customer" is selected; the "Returning
// Customer" flow still submits natively. Field toggling stays in app/assets/javascripts/session.js.
export default function initSignUp (form) {
  const { signUpUrl, wafIntegrationUrl, wafCaptchaUrl, wafCaptchaApiKey } = form.dataset
  const newCustomerRadio = form.querySelector('[data-fields]')
  let integrationReady = null

  // Nothing loads until "New Customer" is picked. A failed load just means submitSignUp falls
  // back to a plain fetch.
  const loadIntegration = () => {
    if (!integrationReady) {
      integrationReady = wafIntegrationUrl
        ? loadScript(wafIntegrationUrl).catch(() => {})
        : Promise.resolve()
    }
    return integrationReady
  }

  if (newCustomerRadio.checked) loadIntegration()
  newCustomerRadio.addEventListener('change', () => {
    if (newCustomerRadio.checked) loadIntegration()
  })

  form.addEventListener('submit', event => {
    if (!newCustomerRadio.checked) return

    event.preventDefault()
    submitSignUp(form, {
      signUpUrl,
      captchaUrl: wafCaptchaUrl,
      captchaApiKey: wafCaptchaApiKey,
      integrationReady: loadIntegration()
    })
  })
}
